import { PlusPrimaryIcon, MinusPrimaryIcon, MinusGray300Icon, PlusGray300Icon } from '@assets/iconComponents';
import { colorSet } from '@theme';
import { Text } from '..';

interface IColumnNumAdjusterProps {
  minColumnNum: number;
  maxColumnNum: number;
  columnNum: number;
  setColumnNum: (value: number | ((prev: number) => number)) => void;
}

export const ColumnNumAdjuster = (props: IColumnNumAdjusterProps) => {
  const { minColumnNum, maxColumnNum, columnNum, setColumnNum } = props;

  const isMinusDisabled = columnNum === minColumnNum;
  const isPlusDisabled = columnNum === maxColumnNum;

  const handleDecrement = () => {
    setColumnNum((prev) => (prev > minColumnNum ? prev - 1 : prev));
  };

  const handleIncrement = () => {
    setColumnNum((prev) => (prev < maxColumnNum ? prev + 1 : prev));
  };

  return (
    <div
      style={{
        height: 32,
        display: 'flex',
        alignItems: 'center',
        border: `1px solid ${colorSet.gray300}`
      }}
    >
      <div
        onClick={handleDecrement}
        style={{
          width: 32,
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRight: `1px solid ${colorSet.gray300}`,
          cursor: isMinusDisabled ? 'default' : 'pointer',
          backgroundColor: isMinusDisabled ? colorSet.gray100 : colorSet.white
        }}
      >
        {isMinusDisabled ? <MinusGray300Icon /> : <MinusPrimaryIcon />}
      </div>
      <div
        style={{
          width: 60,
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: colorSet.gray100
        }}
      >
        <Text variant="subtitle" color={colorSet.gray500} fontWeight="bold" style={{ userSelect: 'none' }}>
          {columnNum}
        </Text>
      </div>
      <div
        onClick={handleIncrement}
        style={{
          width: 32,
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderLeft: `1px solid ${colorSet.gray300}`,
          cursor: isPlusDisabled ? 'default' : 'pointer',
          backgroundColor: isPlusDisabled ? colorSet.gray100 : colorSet.white
        }}
      >
        {isPlusDisabled ? <PlusGray300Icon /> : <PlusPrimaryIcon />}
      </div>
    </div>
  );
};
